<section class="catalog-page">
  <div class="page-heading">
    <div>
      <p>{{ profitOnly ? 'Business pricing' : 'Marketplace catalog' }}</p>
      <h2>{{ profitOnly ? 'Profit rules' : 'Categories and brands' }}</h2>
    </div>
    <button class="secondary" type="button" (click)="loadCatalog()" [disabled]="isLoading">
      <span class="material-symbols-outlined" aria-hidden="true">refresh</span>
      {{ isLoading ? 'Loading...' : 'Refresh' }}
    </button>
  </div>

  @if (!profitOnly) {
  <div class="tabs" role="tablist" aria-label="Catalog management">
    @if (can('CATEGORY_VIEW')) { <button type="button" [class.active]="activeTab === 'categories'" (click)="setTab('categories')">Categories</button> }
    @if (can('BRAND_VIEW')) { <button type="button" [class.active]="activeTab === 'brands'" (click)="setTab('brands')">Brands</button> }
    @if (can('PROFIT_RULE_VIEW')) { <button type="button" [class.active]="activeTab === 'profit'" (click)="setTab('profit')">Profit %</button> }
  </div>
  }

  @if (successMessage) { <p class="state success">{{ successMessage }}</p> }
  @if (errorMessage) { <p class="state error">{{ errorMessage }}</p> }

  @if (activeTab === 'categories') {
    <section class="editor-band">
      <div class="section-heading">
        <div>
          <h3>{{ editingCategoryId ? 'Edit category' : 'Create category' }}</h3>
          <p>Choose the parent level and enter the new category details.</p>
        </div>
        @if (editingCategoryId) {
          <button class="text-action" type="button" (click)="cancelCategoryEdit()">Cancel edit</button>
        }
      </div>
      <form class="catalog-form" (ngSubmit)="saveCategory()">
        <select name="categoryParent" [(ngModel)]="categoryParentCategoryId" (ngModelChange)="onCategoryParentChange()" aria-label="Main category" required>
          <option value="" disabled>Select main category</option>
          @for (category of categoryRootOptions; track category.id) { <option [value]="category.id">{{ category.name }}</option> }
        </select>
        @if (categorySubOptions.length) {
          <select name="categoryParentSub" [(ngModel)]="categoryParentSubCategoryId" aria-label="Parent subcategory">
            <option value="">Create category under selected main category</option>
            @for (category of categorySubOptions; track category.id) { <option [value]="category.id">{{ category.name }}</option> }
          </select>
        }
        <input name="categoryName" [(ngModel)]="categoryForm.name" placeholder="Category name" required />
        <input name="categorySlug" [(ngModel)]="categoryForm.slug" placeholder="Slug (generated if empty)" />
        <label class="file-input">
          <span class="material-symbols-outlined" aria-hidden="true">image</span>
          {{ categoryForm.icon?.name || 'Choose icon' }}
          <input type="file" accept="image/*" (change)="categoryIconChanged($event)" />
        </label>
        <button type="submit" [disabled]="isSaving || !(editingCategoryId ? can('CATEGORY_UPDATE') : can('CATEGORY_CREATE'))">
          <span class="material-symbols-outlined" aria-hidden="true">save</span>
          {{ isSaving ? 'Saving...' : editingCategoryId ? 'Update category' : 'Create category' }}
        </button>
      </form>
    </section>

    <section class="table-panel">
      <table>
        <thead><tr><th>Category</th><th>Level</th><th>Product type</th><th>Status</th><th>Actions</th></tr></thead>
        <tbody>
          @for (category of allCategories; track category.id) {
            <tr>
              <td><span class="item-name">@if (category.iconUrl) { <img [src]="category.iconUrl" [alt]="category.name" /> }<strong>{{ category.name }}</strong></span><small>{{ category.slug }}</small></td>
              <td>{{ parentName(category) }}</td>
              <td>{{ mainCategoryName(category.mainCategory) }}</td>
              <td><span class="status">Active</span></td>
              <td class="row-actions">@if (can('CATEGORY_UPDATE')) { <button class="icon-button" type="button" title="Edit category" (click)="editCategory(category)"><span class="material-symbols-outlined">edit</span></button> }@if (can('CATEGORY_STATUS_UPDATE')) { <button class="icon-button danger" type="button" title="Deactivate category" (click)="deactivateCategory(category)"><span class="material-symbols-outlined">block</span></button> }</td>
            </tr>
          } @empty { <tr><td class="empty" colspan="5">No categories found.</td></tr> }
        </tbody>
      </table>
    </section>
  }

  @if (activeTab === 'brands') {
    <section class="editor-band">
      <div class="section-heading">
        <div><h3>{{ editingBrandId ? 'Edit brand' : 'Create brand' }}</h3><p>Choose the exact category level where this brand is available.</p></div>
        @if (editingBrandId) { <button class="text-action" type="button" (click)="cancelBrandEdit()">Cancel edit</button> }
      </div>
      <form class="catalog-form" (ngSubmit)="saveBrand()">
        <select name="brandCategory" [(ngModel)]="brandCategoryId" (ngModelChange)="onBrandCategoryChange()" aria-label="Main category" required>
          <option value="" disabled>Select main category</option>
          @for (category of brandRootOptions; track category.id) { <option [value]="category.id">{{ category.name }}</option> }
        </select>
        @if (brandSubOptions.length) {
          <select name="brandSubCategory" [(ngModel)]="brandSubCategoryId" (ngModelChange)="onBrandSubCategoryChange()" aria-label="Brand subcategory">
            <option value="">All subcategories</option>
            @for (category of brandSubOptions; track category.id) { <option [value]="category.id">{{ category.name }}</option> }
          </select>
        }
        @if (brandSubSubOptions.length) {
          <select name="brandSubSubCategory" [(ngModel)]="brandSubSubCategoryId" aria-label="Brand sub-subcategory">
            <option value="">All sub-subcategories</option>
            @for (category of brandSubSubOptions; track category.id) { <option [value]="category.id">{{ category.name }}</option> }
          </select>
        }
        <input name="brandName" [(ngModel)]="brandForm.name" placeholder="Brand name" required />
        <input name="brandSlug" [(ngModel)]="brandForm.slug" placeholder="Slug (generated if empty)" />
        <label class="file-input"><span class="material-symbols-outlined">image</span>{{ brandForm.icon?.name || 'Choose icon' }}<input type="file" accept="image/*" (change)="brandIconChanged($event)" /></label>
        <button type="submit" [disabled]="isSaving || !(editingBrandId ? can('BRAND_UPDATE') : can('BRAND_CREATE'))"><span class="material-symbols-outlined">save</span>{{ isSaving ? 'Saving...' : editingBrandId ? 'Update brand' : 'Create brand' }}</button>
      </form>
    </section>

    <section class="table-panel">
      <table>
        <thead><tr><th>Brand</th><th>Category</th><th>Product type</th><th>Status</th><th>Actions</th></tr></thead>
        <tbody>
          @for (brand of brands; track brand.id) {
            <tr>
              <td><span class="item-name">@if (brand.iconUrl) { <img [src]="brand.iconUrl" [alt]="brand.name" /> }<strong>{{ brand.name }}</strong></span><small>{{ brand.slug }}</small></td>
              <td>{{ categoryName(brand.categoryId) }}</td><td>{{ mainCategoryName(brand.mainCategory) }}</td><td><span class="status">Active</span></td>
              <td class="row-actions">@if (can('BRAND_UPDATE')) { <button class="icon-button" type="button" title="Edit brand" (click)="editBrand(brand)"><span class="material-symbols-outlined">edit</span></button> }@if (can('BRAND_STATUS_UPDATE')) { <button class="icon-button danger" type="button" title="Deactivate brand" (click)="deactivateBrand(brand)"><span class="material-symbols-outlined">block</span></button> }</td>
            </tr>
          } @empty { <tr><td class="empty" colspan="5">No brands found.</td></tr> }
        </tbody>
      </table>
    </section>
  }

  @if (activeTab === 'profit') {
    <section class="profit-panel">
      <div class="section-heading">
        <div><h3>Category profit rules</h3><p>Calculate selling price from cost and repair cost using value-based thresholds.</p></div>
        @if (editingProfitRuleId) { <button class="text-action" type="button" (click)="cancelProfitEdit()">Cancel edit</button> }
      </div>
      <form class="profit-form" (ngSubmit)="saveProfitRule()">
        <label><span>Category</span><select name="profitCategory" [(ngModel)]="profitCategoryId" (ngModelChange)="onProfitCategoryChange()" required><option value="" disabled>Select category from catalog</option>@for (category of profitCategories; track category.id) { <option [value]="category.id">{{ categoryDisplayName(category) }}</option> }</select></label>
        <label><span>Minimum product value</span><input type="number" name="minimumProductValue" [(ngModel)]="profitForm.minimumProductValue" min="0" step="1" required /></label>
        <label><span>Profit percentage</span><span class="percentage-input"><input type="number" name="profitPercentage" [(ngModel)]="profitForm.profitPercentage" min="0" max="100" step="0.5" required /><b>%</b></span></label>
        <button type="submit" [disabled]="isSaving || !profitCategoryId || !(editingProfitRuleId ? can('PROFIT_RULE_UPDATE') : can('PROFIT_RULE_CREATE'))"><span class="material-symbols-outlined">save</span>{{ isSaving ? 'Saving...' : editingProfitRuleId ? 'Update rule' : 'Add rule' }}</button>
      </form>
      <div class="profit-rules">
        <div class="profit-rule header"><span>Category</span><span>Minimum value</span><span>Profit</span><span>Status</span><span>Actions</span></div>
        @for (rule of profitRules; track rule.id) {
          <div class="profit-rule">
            <strong>{{ profitCategoryName(rule.categoryId) }}</strong>
            <strong>{{ formatAmount(rule.minimumProductValue) }}</strong>
            <strong>{{ rule.profitPercentage }}%</strong>
            <span class="status" [class.inactive]="!rule.isActive">{{ rule.isActive ? 'Active' : 'Inactive' }}</span>
            <span class="row-actions">@if (can('PROFIT_RULE_UPDATE')) { <button class="icon-button" type="button" title="Edit profit rule" (click)="editProfitRule(rule)"><span class="material-symbols-outlined">edit</span></button> }@if (can('PROFIT_RULE_STATUS_UPDATE')) { <button class="icon-button danger" type="button" title="Deactivate profit rule" [disabled]="!rule.isActive" (click)="deactivateProfitRule(rule)"><span class="material-symbols-outlined">block</span></button> }</span>
          </div>
        } @empty { <p class="empty">{{ isProfitLoading ? 'Loading profit rules...' : 'No profit rules configured yet.' }}</p> }
      </div>
    </section>
  }
</section>
